import React from 'react'
import styled from 'styled-components'
import Flex from 'components/Flex'
import { Pagination as styledPagination } from 'antd'

export const PaginationStyles = styled(styledPagination)`
  z-index: 1;
`
export const FlexWrapper = styled(Flex)`
  padding: 20px 0;
  flex-wrap: wrap;
  position: sticky;
  text-align: center;
  width: ${props => props.width};
`

const Pagination = ({
  onChange,
  totalPages = 0,
  pageSize = 10,
  size = '',
  defaultCurrent = 1,
  width,
  ...rest
}) => {
  return (
    <FlexWrapper center width={width}>
      <PaginationStyles
        showSizeChanger={false}
        onChange={onChange}
        defaultCurrent={defaultCurrent}
        total={totalPages}
        pageSize={pageSize}
        {...rest}
      />
    </FlexWrapper>
  )
}
export default Pagination
